import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FiUsers, FiPhone, FiDollarSign, FiAlertTriangle, FiTrendingUp } from 'react-icons/fi';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminOverview = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const token = localStorage.getItem('adminToken');
            const res = await axios.get(`${API_URL}/admin/stats/overview`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setStats(res.data);
        } catch (err) {
            console.error('Failed to fetch admin stats', err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="animate-pulse">Loading Command Center...</div>;

    const cards = [
        { label: 'Total Users', value: stats?.users.total, sub: `${stats?.users.today} today`, icon: <FiUsers />, color: '#6366f1' },
        { label: 'Guests vs Reg', value: `${stats?.users.guests} / ${stats?.users.registered}`, sub: 'Engagement split', icon: <FiTrendingUp />, color: '#10b981' },
        { label: 'Call Volume', value: `${stats?.calls.totalMinutes} min`, sub: 'Total minutes', icon: <FiPhone />, color: '#f59e0b' },
        { label: 'Failed Calls', value: stats?.calls.failed, sub: 'Needs attention', icon: <FiAlertTriangle />, color: '#ef4444' },
        { label: 'Total Revenue', value: `$${stats?.finance.totalRevenue}`, sub: 'All recharge volume', icon: <FiDollarSign />, color: '#8b5cf6' },
        { label: 'Total Mins Issued', value: `${stats?.finance.totalLiability} min`, sub: 'Outstanding user balances', icon: <FiDollarSign />, color: '#ec4899' },
    ];

    return (
        <div className="animate-fade">
            <h1 style={{ marginBottom: '2rem' }}>Command Center</h1>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
                {cards.map((card, i) => (
                    <div key={i} className="card" style={{ padding: '1.5rem', background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
                            <div style={{ padding: '10px', borderRadius: '12px', background: `${card.color}20`, color: card.color }}>
                                {card.icon}
                            </div>
                        </div>
                        <div style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '4px' }}>{card.value}</div>
                        <div style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-main)' }}>{card.label}</div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '4px' }}>{card.sub}</div>
                    </div>
                ))}
            </div>

            <div style={{ marginTop: '3rem', padding: '2rem', background: 'rgba(255,255,255,0.02)', borderRadius: '1.25rem', border: '1px solid var(--border)', textAlign: 'center' }}>
                <p style={{ color: 'var(--text-muted)' }}>Charts & Advanced Analytics Coming Soon...</p>
            </div>
        </div>
    );
};

export default AdminOverview;
